import { useContext } from 'react';

import { OfferContext } from '@App/contexts/Offer';
import BookCallView from '@Views/shared/BookCallView';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';

const BookCall = () => {
    const { loading } = useContext(OfferContext);

    const successNavLink = '/eligibility/offer/confirmation';

    return (
        <EligibilityLayout loading={loading} showTrustbarV2>
            <BookCallView successNavLink={successNavLink} />
        </EligibilityLayout>
    );
};

export default BookCall;
